<template>
  <v-container fluid style="padding:0; position:relative;">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-xs-center">
        <div class="pb-3">
          <el-select v-model="form.type" placeholder="Select" :size="`small`" class="pr-2">
            <el-option :label="`จำนวนคนเข้าใช้งาน (Pro)`" :value="`feed_liff`"></el-option>
            <el-option :label="`การสั่งซื้อ`" :value="`create_order`"></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button type="primary" class="ml-2" size="mini" @click="viewReport">ค้นหา</el-button>
        </div>
      </v-flex>
    </v-layout>
    <gmap-map
      :center="mapCenter"
      :zoom="16"
      :options="mapConfig"
      ref="map"
      map-type-id="roadmap"
      @center_changed="updateCenter"
      class="map-container"
    >
      <template v-if="logs.length>0">
        <GmapCluster>
          <GmapMarker
            :key="index"
            v-for="(m, index) in logs"
            :position="m.position"
            :clickable="false"
            :draggable="false"
            :icon="{ url: require('../../assets/img/marker-a.png') }"
          />
        </GmapCluster>
      </template>
    </gmap-map>
  </v-container>
</template>
<script>
import Service from "../../services";

import moment from "moment";
export default {
  props: {
    showDialog: { default: false }
  },
  data() {
    return {
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      description: "",
      form: {
        lat: "",
        lng: "",
        type: "feed_liff"
      },
      mapCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      mapConfig: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
        zoom: 11,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5"
              }
            ]
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161"
              }
            ]
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd"
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee"
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161"
              }
            ]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e"
              }
            ]
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5"
              }
            ]
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e"
              }
            ]
          }
        ]
      },
      logs: [],
      markers: []
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  created() {
    let data = {
      begin: moment().format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      type: this.form.type
    };
    Service.Report.heatmap(data).then(res => {
      this.logs = res.data.map(item => {
        return {
          ...item,
          position: new google.maps.LatLng(
            item.log_data_json.coodinates.lat,
            item.log_data_json.coodinates.lng
          )
        };
      });
    });
  },
  methods: {
    viewReport() {
      var duration = moment.duration(
        moment(this.daterange[1]).diff(moment(this.daterange[0]))
      );

      if (duration.asDays() > 0) {
        alert("วันที่เริ่มต้นและวันที่สิ้นสุดต้องเป็นวันเดียวกัน");
        return;
      }

      this.logs = [];

      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        type: this.form.type
      };
      Service.Report.heatmap(data).then(res => {
        this.logs = res.data.map(item => {
          return {
            ...item,
            position: new google.maps.LatLng(
              item.log_data_json.coodinates.lat,
              item.log_data_json.coodinates.lng
            )
          };
        });
      });
    },
    updateCenter(latLng) {
      this.form.lat = latLng.lat();
      this.form.lng = latLng.lng();
    }
  }
};
</script>
<style lang="scss" scoped>
.map-container {
  height: calc(100vh - 6vh);
}

.control {
  padding: 0;
  position: absolute;
  top: 10px;
  z-index: 99;
  width: 100%;
}
</style>